export default __webpack_public_path__ + "static/media/pers2_pc.c8a85c2e.jpg";